import React from 'react';
import { Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DOCUMENT, PAGE_CONTAINER_MAX_WIDTH, documentPageContainerSx } from '../constants/documentTheme';
import PartnerWorkspaceFooter from './PartnerWorkspaceFooter';

export const shouldShowAppPageFooter = (pathname = '') => {
  if (!pathname || pathname === '/') return false;
  if (pathname.startsWith('/admin')) return false;
  if (pathname === '/partner' || pathname.startsWith('/partner/')) return false;
  return true;
};

const AppPageFooter = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (!shouldShowAppPageFooter(pathname)) {
    return null;
  }

  // In-flow footer (not pinned): it sits after the page content so it never
  // covers cards or actions at the bottom of a page. Kept compact — one link
  // row plus the two Seller of Travel lines.
  return (
    <Box
      component="footer"
      data-testid="app-page-footer-bar"
      sx={{
        bgcolor: DOCUMENT.canvas,
        '& [data-testid="seller-footer-lines"] p': {
          fontSize: 10.5,
          lineHeight: 1.45,
        },
      }}
    >
      <Container
        maxWidth={PAGE_CONTAINER_MAX_WIDTH}
        sx={{ ...documentPageContainerSx, pb: 1 }}
      >
        <PartnerWorkspaceFooter
          testId="app-page-footer"
          supportHref="mailto:support@dejavunomad.com"
          sx={{ mt: 0, pt: 1 }}
          links={[
            { href: '/terms', label: t('home.footer.terms') },
            { href: '/privacy', label: t('home.footer.privacy') },
            { href: '/support', label: t('home.footer.support') },
          ]}
        />
      </Container>
    </Box>
  );
};

export default AppPageFooter;
